import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pagerduty",
  "use": "pagerduty-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pagerduty\"><path d=\"M17.668 2H6.332A4.33 4.33 0 0 0 2 6.332v11.336A4.33 4.33 0 0 0 6.332 22h11.336A4.33 4.33 0 0 0 22 17.668V6.332A4.33 4.33 0 0 0 17.668 2M9.821 18.667H7.897v-3.59H9.82zm3.269-5.257H7.897V5.333h5.192a4.038 4.038 0 0 1 .001 8.077M12.577 7H9.821v4.744h2.756a2.372 2.372 0 0 0 0-4.744\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol